import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-133" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-134" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="Гаранција задовољства од 7 дана" data-id="element-135" data-mp="222wjc7wug0nm">
          <defs data-id="element-136" data-mp="19dzbyzu67o9n">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-137" data-mp="19fismrjqo1by" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-138" data-mp="14hhb4b1yoa2l" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-139" data-mp="1j6554cw5sbqf" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-140" data-mp="1ec99vi7a52yy">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-141" data-mp="lp6a6mqvam74">
              ГАРАНЦИЈА ЗАДОВОЉСТВА · КУПУЈТЕ БЕЗБЕДНО ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-142" data-mp="oxp0pyicqyys">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="yqmcllsu9pof">
            ДАНА
          </text>
        </svg>

        <div data-id="element-144" data-mp="62i4ktmsp0ik">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-145" data-mp="62qlcwm1gpz1">
            Гаранција задовољства од 7 дана
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-146" data-mp="f0kczu8uyvfv">
            Преузмите материјал и погледајте како функционише на вашим часовима математике. Ако
            противно очекивањима нисте задовољни пакетом, можете да нам пишете и да добијете повраћај
            новца у року од 7 дана од куповине, према условима гаранције.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-147" data-mp="3rigo8yf1tanl">
            Гаранција ни на који начин не ограничава ваша права по закону о заштити потрошача.
          </p>
        </div>
      </div>
    </section>;
}